import { render, staticRenderFns } from "./goods-details.vue?vue&type=template&id=4772d2ae&scoped=true&"
import script from "./goods-details.vue?vue&type=script&lang=js&"
export * from "./goods-details.vue?vue&type=script&lang=js&"
import style0 from "./goods-details.vue?vue&type=style&index=0&id=4772d2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772d2ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4772d2ae')) {
      api.createRecord('4772d2ae', component.options)
    } else {
      api.reload('4772d2ae', component.options)
    }
    module.hot.accept("./goods-details.vue?vue&type=template&id=4772d2ae&scoped=true&", function () {
      api.rerender('4772d2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/goods-change-dialog/modules/goods-details.vue"
export default component.exports